import React from "react";
import { Badge } from "ctia-react-bootstrap-v4";

const RecognitionBadge = () => {
  return <Badge variant="info">Pending Recognition</Badge>;
};

export default RecognitionBadge;
